export default function List({ items }: { items: string[] }): React.ReactElement {
  return (
    <ul className="ml-6 list-disc list-outside text-black-light">
      {items.map((elem) => (
        <li className="leading-7" key={elem}>
          {elem}
        </li>
      ))}
    </ul>
  )
}
